export default __webpack_public_path__ + "static/media/ic-test-published.ac306343.svg";